// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__3KXqG","form":"styles_form__1t-Yy"};